/**
 * Class description
 *
 * Created: 2019-08-13
 * @author jonas
 */

import {BasicBitmapCountUp} from "../display/BasicBitmapCountUp";
import {ImmortalFruitsTextStyles} from "../config/ImmortalFruitsTextStyles";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Ease, Linear, TimelineLite, TweenLite} from "gsap";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import { ImmortalFruitsLayerConfig} from "../config/IImmortalFruitsLayerConfig";
import {SoundManager} from "../resource/sound/SoundManager";
import {ImmortalFruitsSoundConfig} from "../ImmortalFruitsSoundConfig";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {ImmortalFruitsGameConfig} from "../ImmortalFruitsGameConfig";

export class CountUpView extends BaseView {
    private _layer: ScalableLayer;
    private _bitmapText: BasicBitmapCountUp;
    private _soundPlaying: boolean = false;

    /**
     * @constructs
     */
    constructor() {
        super();
        this._layer = StageManager.getLayer(ImmortalFruitsLayerConfig.WIN_COUNT_UP.name);
    }

    /**
     * @description This method calculates the text scale.
     * @param from
     * @param to
     */
    public calculateTextScale(from: number, to: number) {
        this._bitmapText.preCalculateScale(from, to);
    }

    /**
     * @description This method is used for the count up animation.
     * @param from
     * @param to
     * @param duration
     * @param ease
     */
    public getWinStepAnimation(from: number, to: number, duration: number, ease: Ease = Linear.easeNone, isBigWin : boolean = false, isBonus : boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        tl.add(() => {
            this._layer.addChild(this);
            if (!ImmortalFruitsGameConfig.instance.WIN_BELOW_STAKE) {// #305
                this.startCountUpSound(isBigWin, isBonus);
            }
        });
        tl.add(this._bitmapText.getCountAnimation(from, to, duration, ease));

        return tl;
    }

    /**
     * @inheritDoc
     * @param value
     */
    public abort(value: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => this._bitmapText.stopAt(value));

        return tl;
    }

    /**
     * @description This method gives us the end animation of count up.
     * @param value
     * @param displayDuration
     * @param fadeDuration
     */
    public end(value: number, displayDuration: number, fadeDuration: number, isBigWin : boolean = false, isBonus : boolean = false, dontPlayCountUpEnds : boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._layer.addChild(this);
            !dontPlayCountUpEnds && this.stopCountUpSound(isBigWin, isBonus);
            this._bitmapText.stopAt(value);
            SlotGame.winFieldController.showWinField();
        });
        tl.add(() => this.fadeAndRemove(fadeDuration), displayDuration);
        return tl;
    }

    /**
     * @inheritDoc
     */
    protected initAnimations(): void {
        this._bitmapText = new BasicBitmapCountUp(ImmortalFruitsTextStyles.WIN_COUNT_UP, GameConfig.instance.REEL_AREA_WIDTH, new PIXI.Point(0.5, 0.5));
        this._bitmapText.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.5 + GameConfig.instance.REEL_AREA_POS_X - 35, GameConfig.instance.REEL_AREA_HEIGHT * 0.5 + GameConfig.instance.REEL_AREA_POS_Y);
        this.addChild(this._bitmapText);
    }

    /**
     * @description This method removes the count up item using the fade out effect.
     * @param fadeDuration
     */
    private fadeAndRemove(fadeDuration: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this, fadeDuration, {alpha: 0, ease: Linear.easeNone}));
        tl.add(() => {
            this._layer.removeChild(this);
            this.alpha = 1;
        });
        return tl;
    }

    /**
     * @description To start the count up sound.
     */
    private startCountUpSound(isBigWin : boolean = false,  isBonus : boolean = false) {
        if (!this._soundPlaying) {
            if(isBigWin){
                //SoundManager.fadeOutMainBGSound(500);
                SoundManager.playBigWinCountUp();
                SoundManager.playBigWin();
                isBonus ? SoundManager.fadeOutBonusBG(500) : SoundManager.fadeOutMainBGSound(500);
            }else{
                Logger.log("sound countUp");
                SoundManager.playSound(ImmortalFruitsSoundConfig.instance.COUNT_UP, 999)
            }
            this._soundPlaying = true;
        }
    }

    /**
     * @description To stop the count up sound.
     */
    private stopCountUpSound( isBigWin : boolean = false, isBonus : boolean = false) {
        if (this._soundPlaying) {
            SoundManager.stopBigWinCountUp();
            SoundManager.stopBigWin();
            SoundManager.stopSound(ImmortalFruitsSoundConfig.instance.COUNT_UP);
            isBigWin && !isBonus && SoundManager.fadeInMainBGSound(2000);//TODO
            this._soundPlaying = false;
        }
        if (!ImmortalFruitsGameConfig.instance.WIN_BELOW_STAKE) {// #305
            isBigWin ? SoundManager.playBigWinEnds() : SoundManager.playCountUpEnds();
        }
    }
}